import type { ReactNode } from 'react';

export const symbol_rear_camera: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m251-355 104-104q9-9 9-21t-9-21L251-605q-9-9-21-9t-21 9q-9 9-9 21t9 21l53 53H110q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32Q97.25-450 110-450h152l-53 53q-9 9-9 21t9 21q9 9 21 9t21-9Zm435.5-303.68q8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5 12.82 0 21.32-8.68ZM510-180h310v-600H510v600Zm-370 60q-24 0-42-18t-18-42v-180q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v180h310v-600H140v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q80-587.25 80-600v-180q0-24 18-42t42-18h680q24 0 42 18t18 42v600q0 24-18 42t-42 18H140Zm310-660v600-600Z"
		/>
	</svg>
);
